import type { AuthUser, Role } from '../types/api';

export type SessionUser = AuthUser;

const TOKEN_KEY = 'datong.token';
const USER_KEY = 'datong.user';
const KIOSK_KEY = 'datong.kiosk_session';
const DEVICE_KEY = 'datong.kiosk_device';

function storage(): Storage | null {
  try {
    return sessionStorage;
  } catch {
    return null;
  }
}

export function getToken(): string | null {
  return storage()?.getItem(TOKEN_KEY) ?? null;
}

export function getUser(): AuthUser | null {
  const raw = storage()?.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as AuthUser;
  } catch {
    return null;
  }
}

export function getKioskSession(): string | null {
  return storage()?.getItem(KIOSK_KEY) ?? null;
}

export function getOrCreateDeviceId(): string {
  const s = storage();
  const existing = s?.getItem(DEVICE_KEY);
  if (existing) return existing;
  const id = crypto.randomUUID();
  s?.setItem(DEVICE_KEY, id);
  return id;
}

export function setSession(params: {
  token: string;
  user: AuthUser;
  kioskSessionId?: string;
}): void {
  const s = storage();
  s?.setItem(TOKEN_KEY, params.token);
  s?.setItem(USER_KEY, JSON.stringify(params.user));
  if (params.kioskSessionId) {
    s?.setItem(KIOSK_KEY, params.kioskSessionId);
  } else {
    s?.removeItem(KIOSK_KEY);
  }
}

export function clearSession(): void {
  const s = storage();
  s?.removeItem(TOKEN_KEY);
  s?.removeItem(USER_KEY);
  s?.removeItem(KIOSK_KEY);
}

export function homePath(role: Role, kiosk: boolean): string {
  if (kiosk) return '/kiosk/courses';
  if (role === 'admin') return '/admin/home';
  if (role === 'teacher') return '/teacher/schedule';
  return '/student/home';
}
